import { ArrowRight, BadgeCheck, Headphones, Languages, Plane } from "lucide-react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Logo } from "../components/Logo";

export function WelcomePage() {
  const { token } = useAuth();
  if (token) return <Navigate to="/app" replace />;
  return (
    <div className="welcome-page">
      <header className="welcome-header"><Logo /><Link to="/login" className="text-link">Ingresar</Link></header>
      <main className="welcome-main">
        <div className="eyebrow"><BadgeCheck size={16} /> Aplicación oficial XR4</div>
        <div className="hero-visual" aria-hidden="true">
          <div className="hero-ring ring-one" />
          <div className="hero-ring ring-two" />
          <div className="hero-device"><Headphones size={52} strokeWidth={1.8} /></div>
          <div className="language-pill pill-left">Hola</div>
          <div className="language-pill pill-right">Hello</div>
        </div>
        <h1>Entendé el mundo.<br /><span>Respondé con confianza.</span></h1>
        <p className="hero-copy">Activá tus LingoSound XR4 y traducí conversaciones, viajes y situaciones reales desde un solo lugar.</p>
        <div className="hero-actions">
          <Link to="/register" className="button primary large">Crear mi cuenta <ArrowRight size={19} /></Link>
          <Link to="/login" className="button secondary large">Ya tengo una cuenta</Link>
        </div>
        <div className="feature-row">
          <div><Languages size={20} /><span><strong>+100 idiomas</strong><small>Traducción segura</small></span></div>
          <div><Plane size={20} /><span><strong>Modo viaje</strong><small>Situaciones reales</small></span></div>
          <div><Headphones size={20} /><span><strong>Con tus XR4</strong><small>Audio en el oído</small></span></div>
        </div>
        <div className="legal-links"><Link to="/privacy">Privacidad</Link><Link to="/terms">Términos</Link><a href="mailto:ventas@lingosound.com">Soporte</a></div>
      </main>
    </div>
  );
}
